/**
 * The single z-index scale. Nothing in the app may invent a stacking value — if two things
 * overlap, their relationship is decided here.
 */
export const depths = {
  base: 0,
  sidebar: 400,
  consoleBar: 800,
  menu: 900,
  dialogOverlay: 1000,
  dialog: 1100,
  toast: 1200,
  tooltip: 1300,
} as const;

export type Depth = keyof typeof depths;
